import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledDropdown } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, validateSomaliaPhoneNumber } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Swal from 'sweetalert2';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    const PPMLibrary = () => {

        toastr.options = TOAST_OPTIONS;
        const [modal_type, setmodal_type] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [typeList, setTypeList] = useState([])
        const [isLoading, setIsLoading] = useState(false)

        const [assetType, setAssetType] = useState('')
        const [assetTypeId, setAssetTypeId] = useState('')
        const [units, setUnits] = useState('')
        const [aText, setAText] = useState('')
        const [bText, setBText] = useState('')
        const [cText, setCText] = useState('')
        const [dText, setDText] = useState('')
       

        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_type = () => {
          setmodal_type(!modal_type)
          removeBodyCss()
        }

        const fetchData = () => {
          setIsLoading(true)
          axios.get(url.TYPES, Config).then((r)=>{ 
            console.log(r)
            setTypeList(r.data); 
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
         
        }
        
        useEffect(() => {
          fetchData();
        },[]);
        const handleAddAssetType = () =>{
            setIsEdit(false)
            clearData()
            tog_type()
        }
        const clearData =() =>{
            setAssetTypeId('')
            setAssetType('')
            setUnits('')
            setAText('')
            setBText('')
            setCText('')
            setDText('')
        }
        const handleSave = () =>{
          if(assetType.trim().length < 2){
            toastr.error("Enter asset type")
          }else{
            let data = {}
            if(isEdit){
              data = {
                id          :  assetTypeId,
                assetType   :  assetType,
                units       :  units,
                aText       :  aText,
                bText       :  bText,
                cText       :  cText,
                dText       :  dText,
                action      :  "edit"
              }
            }else{
              data = {
                assetType   :  assetType,
                units       :  units,
                aText       :  aText,
                bText       :  bText,
                cText       :  cText,
                dText       :  dText,
                action      : "add"
              }
            }
            //console.log(JSON.stringify(data))
            setIsLoading(true)
            axios.post(url.TYPES, JSON.stringify(data), Config).then((r)=>{
              if(r.data.status == '1'){
                toastr.success(r.data.message)
                tog_type()
                setIsEdit(false)
                fetchData()
                clearData()
              }else{
                toastr.error(r.data.message)
              }
              setIsLoading(false)
            }).catch((e)=>{
              console.log(e)
              setIsLoading(false)
            })
          }
        }
       
        const handleClickDetails = (c) =>{
          setIsEdit(true)
          setAssetTypeId(c.id)
          setAssetType(c.type)
          setUnits(c.unit)
          setAText(c.a)
          setBText(c.b)
          setCText(c.c)
          setDText(c.d)
          tog_type()
        }
       
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>PPM Library | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Row>
                                      

                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">PPM Instructions Library</h5>
                                <CardBody>

                                <Modal isOpen={modal_type} toggle={() => { tog_type(); }}  size="xl" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Asset Type`:`Add Asset Type` }</h5>
                                    <button type="button"  onClick={() => { setmodal_type(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Asset Type</label>
                                                <input type='text' className="form-control" value={assetType} onChange={(e)=>setAssetType(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Units for Sizing</label>
                                                <input type='text' className="form-control" value={units} onChange={(e)=>setUnits(e.target.value)} />
                                            </div>
                                        </Col>
                                      
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>PPM service A Instructions</label>
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={aText} 
                                                  onReady={editor => {
                                                    //console.log('Editor is ready to use!', editor);
                                                  }}
                                                  onChange={(event, editor) => {
                                                    //const data = editor.getData();
                                                    setAText(editor.getData())
                                                  }}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>PPM service B Instructions</label>
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={bText} 
                                                  onReady={editor => {
                                                    //console.log('Editor is ready to use!', editor);
                                                  }}
                                                  onChange={(event, editor) => {
                                                    //const data = editor.getData();
                                                    setBText(editor.getData())
                                                  }}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>PPM service C Instructions</label>
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={cText} 
                                                  onReady={editor => {
                                                    //console.log('Editor is ready to use!', editor);
                                                  }}
                                                  onChange={(event, editor) => {
                                                    //const data = editor.getData();
                                                    setCText(editor.getData())
                                                  }}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>PPM service D Instructions</label>
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={dText} 
                                                  onReady={editor => {
                                                    //console.log('Editor is ready to use!', editor);
                                                  }}
                                                  onChange={(event, editor) => {
                                                    //const data = editor.getData();
                                                    setDText(editor.getData())
                                                  }}
                                                />
                                            </div>
                                        </Col>

                                    
                                       
                                  </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                  {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                      : ( <button type="button" className="btn btn-success" onClick={()=>handleSave()}>Save...</button> )
                                  }</div>
                                </Modal>

                                <div>
                                    <Row className="mb-0">
                                    <Col xl={6} sm={6}>
                                        
                                    </Col>
                                    <Col xl={6} sm={6}>
                                        <Form className="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
                                        <div className="search-box mb-2 me-2">
                                           
                                        </div>
                                        <UncontrolledDropdown className="mb-0" direction="right">
                                            <DropdownToggle
                                            color="white"
                                            className="btn btn-link text-muted mt-n2"
                                            onClick={()=>{handleAddAssetType}}
                                            >
                                            <i className="mdi mdi-book-plus-multiple font-size-24 text-success"></i>
                                            </DropdownToggle>
                                        </UncontrolledDropdown>
                                        </Form>
                                    </Col>
                                    </Row>
                                </div>
                                
                                <div className="table">
                                  <Table className="table table-sm m-0">
                                    <thead>
                                      <tr>
                                        <th>No</th>
                                        <th>Asset Type</th>
                                        <th>Sizing Units</th>
                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>PPM A</th>
                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>PPM B</th>
                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>PPM C</th>
                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>PPM D</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    {typeList.map((c,k)=>(
                                      <tr key={k}>
                                        <td>{k+1}</td>
                                        <td>{c.type}</td>
                                        <td>{c.unit}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{(c.a != null) && (c.a.length > 10)?<i className="mdi mdi-file font-size-18 text-success"></i>:<i className="mdi mdi-file font-size-18 text-danger"></i>}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{(c.b != null) && (c.b.length > 10)?<i className="mdi mdi-file font-size-18 text-success"></i>:<i className="mdi mdi-file font-size-18 text-danger"></i>}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{(c.c != null) && (c.c.length > 10)?<i className="mdi mdi-file font-size-18 text-success"></i>:<i className="mdi mdi-file font-size-18 text-danger"></i>}</td>
                                        <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{(c.d != null) && (c.d.length > 10)?<i className="mdi mdi-file font-size-18 text-success"></i>:<i className="mdi mdi-file font-size-18 text-danger"></i>}</td>
                                        <td>
                                        <div className="d-flex gap-3">
                                         
                                            <Button
                                                  type="button"
                                                  color="info"
                                                  className="btn-sm btn-rounded"
                                                  onClick={()=>{handleClickDetails(c)}}
                                                >
                                                  Details
                                            </Button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))} 
                                    </tbody>
                                                          
                                  </Table>
                                </div>

                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default PPMLibrary;